/*
 *
 * ManageStructurePopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 29-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import './ManageStructurePopup.scss'
import { useIntl } from 'react-intl'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalSwitch from '@nexidigital/portalswitch'
import StructurePhoneInput from 'Components/StructurePhoneInput'
import StructureTextInput from 'Components/StructureTextInput'
import StructureTimePicker from 'Components/StructureTimePicker'
import useStructureForm from 'Hooks/useStructureForm'
import { messages } from './languageModule'

const ManageStructurePopup = ({ actions, data: structure, isLoading }) => {
  const intl = useIntl()
  const formik = useStructureForm(structure)

  const onSubmit = (values) => {
    actions.doModifyStructure(values)
  }

  return (
    <MerchantModal
      bigPopup
      topBarTitle={intl.formatMessage(messages.manageStructure)}
      onClose={() => actions.closePopup()}
      primaryAction={() => onSubmit(formik.values)}
      primaryButtonLoading={isLoading}
      primaryButtonDisabled={!formik.dirty || !formik.isValid}
      primaryButtonLabel={intl.formatMessage(messages.confirm)}
      closeLabel={intl.formatMessage(messages.close)}>
      <MerchantGenericCard
        title={intl.formatMessage(messages.generalInformations)}
        toggle={
          <PortalSwitch
            onChange={(val) => formik.setFieldValue('status', val === true ? 'ACTIVE' : 'INACTIVE')}
            activeLabel={intl.formatMessage(messages.Enabled)}
            deactiveLabel={intl.formatMessage(messages.Disabled)}
            checked={formik.values.status === 'ACTIVE' ? true : false}
          />
        }>
        <div className='manageStructureForm'>
          <section className='generalInfo'>
            <StructureTextInput formik={formik} id='name' label={intl.formatMessage(messages.structureName)} />
            <StructureTextInput
              formik={formik}
              id='code'
              label={intl.formatMessage(messages.structureCode)}
              maxLength={255}
            />
            <StructureTextInput formik={formik} id='email' label={intl.formatMessage(messages.email)} type='email' />
            <StructurePhoneInput formik={formik} />
          </section>
          <section className='checkInOut'>
            <StructureTimePicker
              formik={formik}
              field='checkIn'
              labelStart={intl.formatMessage(messages.checkInFrom)}
              labelEnd={intl.formatMessage(messages.checkInTo)}
            />
            <StructureTimePicker
              formik={formik}
              field='checkOut'
              labelStart={intl.formatMessage(messages.checkOutFrom)}
              labelEnd={intl.formatMessage(messages.checkOutBy)}
            />
            {/* <PortalTimeField
                        label={'Check-out entro*'}
                        defaultValue={formik.values.checkOut}
                        value={formik.values.checkOut}
                        onChange={(newValue) => {
                          formik.setFieldValue('checkOut', newValue)
                        }}
                      /> */}
          </section>
          <p className='requiredField'>{intl.formatMessage(messages.requiredField)}</p>
        </div>
      </MerchantGenericCard>
    </MerchantModal>
  )
}

ManageStructurePopup.propTypes = {
  actions: PropTypes.object.isRequired,
  data: PropTypes.object,
  isLoading: PropTypes.bool
}

ManageStructurePopup.defaultProps = {
  actions: {},
  isLoading: false
}

export default ManageStructurePopup
